import React from 'react';

import ReactDocumentTitle from 'react-document-title';

import { type InjectedDocumentTitleProps, withDocumentTitleHOC } from '../AppConfigContext';

import { type DocumentTitleProps } from './types';

export function DocumentTitle(
	props: React.PropsWithChildren<DocumentTitleProps & InjectedDocumentTitleProps>,
) {
	const { children, docTitle, title } = props;

	const resultTitle = [docTitle.start, title, docTitle.end]
		.filter((s) => Boolean(s))
		.join(docTitle.delimiter || ' - ');

	return (
		// @ts-ignore
		<ReactDocumentTitle title={resultTitle}>{children}</ReactDocumentTitle>
	);
}

export default withDocumentTitleHOC(DocumentTitle);
